import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from 'sonner';
import { ArrowLeft, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/forgot-password`, { email });
      toast.success(response.data.message);
      setSent(true);
      // Redirect to reset password page after 2 seconds
      setTimeout(() => {
        navigate('/reset-password', { state: { email } });
      }, 2000);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div className="w-full max-w-md">
        <Card>
          <CardContent className="p-8">
            <Button
              onClick={() => navigate('/login')}
              variant="ghost"
              className="mb-6"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Back to Login
            </Button>

            <div className="flex justify-center mb-6">
              <div className="bg-gradient-to-br from-purple-500 to-indigo-600 p-4 rounded-2xl">
                <Mail className="w-12 h-12 text-white" />
              </div>
            </div>

            <h1 className="text-3xl font-bold text-center mb-2">Forgot Password?</h1>
            <p className="text-center text-gray-600 mb-8">
              Enter your email and we'll send you a 6-digit OTP code
            </p>

            {!sent ? (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Label htmlFor="email">Email Address</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="mt-1"
                    placeholder="your@email.com"
                    data-testid="email-input"
                  />
                </div>

                <Button
                  type="submit"
                  className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-medium py-6 rounded-xl"
                  disabled={loading}
                  data-testid="submit-button"
                >
                  {loading ? 'Sending...' : 'Send OTP Code'}
                </Button>
              </form>
            ) : (
              <div className="text-center">
                <div className="bg-green-50 border border-green-200 rounded-xl p-6 mb-6">
                  <p className="text-green-800">
                    OTP code sent! Check your email and enter the code on the next page.
                  </p>
                  <p className="text-green-700 text-sm mt-2">
                    Redirecting to reset password page...
                  </p>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
